export const environment = {
  firebase: {
    apiKey: "AIzaSyAiykT3uqzE0hTJa2waVB0FwTTcJk84rOk",
    authDomain: "dev.datamorf.io",
    projectId: "call-center-d08cb",
    storageBucket: "call-center-d08cb.appspot.com",
    messagingSenderId: "1030804807834",
    appId: "1:1030804807834:web:8b02ec1205399fef1e3f23"
  },
  production: false,
  fireServer: 'https://us-central1-call-center-d08cb.cloudfunctions.net/',
  core: 'http://localhost:6060/',
  // core: 'https://core-dev.datamorf.io/',
  // core: 'https://core.datamorf.io/',
  extractor: 'http://localhost:3000/',
  integrations: {
    googlePicker: "AIzaSyAVZ07WRxU1hzSMX2-7cqNYKAiwbGyodFs",
    calendly: {
      clientId: 'tafzhfi59y38LP9Y3hb045npZkuJhx_5ZT_Sn597SW0',
      redirectUri: 'https://auth.calendly.com/oauth/authorize?client_id=tafzhfi59y38LP9Y3hb045npZkuJhx_5ZT_Sn597SW0&response_type=code&redirect_uri=http://localhost:4200/integrations/calendly'
    },
    gmail: {
      clientId: '1030804807834-d6r4cug494otsvir80i1oshsjghalmbt.apps.googleusercontent.com'
    },
    gforms: {
      clientId: '1030804807834-0h6a0j6trvr78gkrm6k34td3tsajtc9g.apps.googleusercontent.com'
    },
    pipedrive: {
      clientId: '1503bb46cb704cd5'
    },
    dropbox: {
      redirectUrl: 'https://www.dropbox.com/oauth2/authorize?client_id=y69x12cb6kmj0i4&redirect_uri=http://localhost:4200/integrations/dropbox&response_type=code&token_access_type=offline'
    },
    googleCalendar: {
      clientId: '666583135439-qfjjukcd1ke2n037b2jb6ulc4b4p42fk.apps.googleusercontent.com'
    },
    attio: {
      clientId: '3132200f-c0f1-484a-aa88-e1a7815344c3'
    }
  },
  consultationLink: 'https://calendly.com/axel-datamorf/chat-with-axel',
  cannyAppId: '665de06df65c29edf8728940',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

